import {Link} from "@bonprix/design-system";

export default function createInformationLayerTextWithLink(value, linkTarget) {
    const parts = value.split(/{(.*?)}/g);
    return parts.map((part, index) => {
        if (index % 2 === 1) {
            return (
                <Link key={index} href={linkTarget} target="_blank">
                    {part}
                </Link>
            );
        }
        return part;
    });
}
